<script setup>
import TextInput from '@/components/TextInput.vue';
import { onMounted, watch, ref, reactive } from 'vue';
import ModalShow from '@/components/ModalShow.vue';
import { useRoute, useRouter } from 'vue-router';
import api from "@/libs/api.js";
import EventBus from "@/libs/eventBus";
const router = useRouter();
const loading = ref(false);
const emit = defineEmits(["callBack", "callApi"])

const form = ref({
    id: '',
    password: '',
    new_password: '',
    new_password_confirmation: '',
});
const showPassword = ref(false);
const showNewPassword = ref(false);
const showNewPasswordConfirmation = ref(false);
const errors = ref({});
const modalLogin = ref(false);

const submit = () => {
    loading.value = true;
    api.patch('app/user-update-password/' + form.value.id, form.value)
        .then((response) => {
            loading.value = false;
            modalLogin.value = true;
             EventBus.emit('show-notification', JSON.stringify({
                    id: '',
                    title: "Thông báo!",
                    message: `Bạn vừa thay đổi mật khẩu.`,
                    url: '',
                    type: 'success',
                    showtime: 2000
                }));
        }).catch((error) => {
            if (error.response.status === 422) {
                errors.value = error.response.data.errors;
            }
        });
};

const close = () => {
    router.push({ name: 'user' })
};

</script>

<template>
    <ModalShow :show="true" title="Thay đổi mật khẩu" @call-back="close">
        <img src="@/assets/images/Reset_password_compressed.png" alt="" class="w-3/5 object-contain mx-auto">
        <div class="w-full pt-4 px-6">
            <label for="password" class="font-semibold">
                Mật khẩu hiện tại
                <span class="text-red-600">*</span>
            </label>
            <div class="relative h-auto">
                <TextInput id="password" :type="showPassword ? 'password' : 'text'" class="mt-1 block w-full pr-14"
                    v-model="form.password" autocomplete="current-password" />
                <div @click="showPassword = !showPassword"
                    class="absolute w-14 h-full top-0 right-0 flex justify-center items-center">
                    <svg v-if="showPassword" class="w-6 h-6 fill-gray-500" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512">
                        <g id="Layer_16" data-name="Layer 16">
                            <path
                                d="m419.72 419.72-327.46-327.45-.07-.08a19 19 0 0 0 -26.78 27l28.67 28.67a332.64 332.64 0 0 0 -88.19 89 34.22 34.22 0 0 0 0 38.38c59.97 88.76 155.04 140.76 250.11 140.11a271.6 271.6 0 0 0 90.46-15.16l46.41 46.41a19 19 0 0 0 26.94-26.79zm-163.72-55.98a107.78 107.78 0 0 1 -98.17-152.18l29.95 29.95a69.75 69.75 0 0 0 82.71 82.71l29.95 29.95a107.23 107.23 0 0 1 -44.44 9.57z" />
                            <path
                                d="m506.11 236.81c-59.97-88.81-155.04-140.81-250.11-140.16a271.6 271.6 0 0 0 -90.46 15.16l46 46a107.78 107.78 0 0 1 142.63 142.63l63.74 63.74a332.49 332.49 0 0 0 88.2-89 34.22 34.22 0 0 0 0-38.37z" />
                            <path
                                d="m256 186.26a69.91 69.91 0 0 0 -14.49 1.52l82.71 82.7a69.74 69.74 0 0 0 -68.22-84.22z" />
                        </g>
                    </svg>
                    <svg v-else class="w-6 h-6 fill-gray-500" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 488.85 488.85" style="enable-background:new 0 0 488.85 488.85;"
                        xml:space="preserve">
                        <g>
                            <path
                                d="M244.425,98.725c-93.4,0-178.1,51.1-240.6,134.1c-5.1,6.8-5.1,16.3,0,23.1c62.5,83.1,147.2,134.2,240.6,134.2   s178.1-51.1,240.6-134.1c5.1-6.8,5.1-16.3,0-23.1C422.525,149.825,337.825,98.725,244.425,98.725z M251.125,347.025   c-62,3.9-113.2-47.2-109.3-109.3c3.2-51.2,44.7-92.7,95.9-95.9c62-3.9,113.2,47.2,109.3,109.3   C343.725,302.225,302.225,343.725,251.125,347.025z M248.025,299.625c-33.4,2.1-61-25.4-58.8-58.8c1.7-27.6,24.1-49.9,51.7-51.7   c33.4-2.1,61,25.4,58.8,58.8C297.925,275.625,275.525,297.925,248.025,299.625z" />
                        </g>
                    </svg>
                </div>
            </div>
            <p v-if="errors && errors.password" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.password }}
            </p>
        </div>
        <div class="w-full pt-4 px-6">
            <label for="new_password" class="font-semibold">
                Mật khẩu mới
                <span class="text-red-600">*</span>
            </label>
            <div class="relative h-auto">
                <TextInput id="new_password" :type="showNewPassword ? 'password' : 'text'"
                    class="mt-1 block w-full pr-14" v-model="form.new_password" autocomplete="current-password" />
                <div @click="showNewPassword = !showNewPassword"
                    class="absolute w-14 h-full top-0 right-0 flex justify-center items-center">
                    <svg v-if="showNewPassword" class="w-6 h-6 fill-gray-500" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512">
                        <g id="Layer_16" data-name="Layer 16">
                            <path
                                d="m419.72 419.72-327.46-327.45-.07-.08a19 19 0 0 0 -26.78 27l28.67 28.67a332.64 332.64 0 0 0 -88.19 89 34.22 34.22 0 0 0 0 38.38c59.97 88.76 155.04 140.76 250.11 140.11a271.6 271.6 0 0 0 90.46-15.16l46.41 46.41a19 19 0 0 0 26.94-26.79zm-163.72-55.98a107.78 107.78 0 0 1 -98.17-152.18l29.95 29.95a69.75 69.75 0 0 0 82.71 82.71l29.95 29.95a107.23 107.23 0 0 1 -44.44 9.57z" />
                            <path
                                d="m506.11 236.81c-59.97-88.81-155.04-140.81-250.11-140.16a271.6 271.6 0 0 0 -90.46 15.16l46 46a107.78 107.78 0 0 1 142.63 142.63l63.74 63.74a332.49 332.49 0 0 0 88.2-89 34.22 34.22 0 0 0 0-38.37z" />
                            <path
                                d="m256 186.26a69.91 69.91 0 0 0 -14.49 1.52l82.71 82.7a69.74 69.74 0 0 0 -68.22-84.22z" />
                        </g>
                    </svg>
                    <svg v-else class="w-6 h-6 fill-gray-500" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 488.85 488.85" style="enable-background:new 0 0 488.85 488.85;"
                        xml:space="preserve">
                        <g>
                            <path
                                d="M244.425,98.725c-93.4,0-178.1,51.1-240.6,134.1c-5.1,6.8-5.1,16.3,0,23.1c62.5,83.1,147.2,134.2,240.6,134.2   s178.1-51.1,240.6-134.1c5.1-6.8,5.1-16.3,0-23.1C422.525,149.825,337.825,98.725,244.425,98.725z M251.125,347.025   c-62,3.9-113.2-47.2-109.3-109.3c3.2-51.2,44.7-92.7,95.9-95.9c62-3.9,113.2,47.2,109.3,109.3   C343.725,302.225,302.225,343.725,251.125,347.025z M248.025,299.625c-33.4,2.1-61-25.4-58.8-58.8c1.7-27.6,24.1-49.9,51.7-51.7   c33.4-2.1,61,25.4,58.8,58.8C297.925,275.625,275.525,297.925,248.025,299.625z" />
                        </g>
                    </svg>
                </div>
            </div>
            <p v-if="errors && errors.new_password" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.new_password }}
            </p>
        </div>
        <div class="w-full pt-4 px-6">
            <label for="new_password_confirmation" class="font-semibold">
                Nhập lại mật khẩu mới
                <span class="text-red-600">*</span>
            </label>
            <div class="relative h-auto">
                <TextInput id="new_password_confirmation" :type="showNewPasswordConfirmation ? 'password' : 'text'"
                    class="mt-1 block w-full pr-14" v-model="form.new_password_confirmation"
                    autocomplete="current-password" />
                <div @click="showNewPasswordConfirmation = !showNewPasswordConfirmation"
                    class="absolute w-14 h-full top-0 right-0 flex justify-center items-center">
                    <svg v-if="showNewPasswordConfirmation" class="w-6 h-6 fill-gray-500"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <g id="Layer_16" data-name="Layer 16">
                            <path
                                d="m419.72 419.72-327.46-327.45-.07-.08a19 19 0 0 0 -26.78 27l28.67 28.67a332.64 332.64 0 0 0 -88.19 89 34.22 34.22 0 0 0 0 38.38c59.97 88.76 155.04 140.76 250.11 140.11a271.6 271.6 0 0 0 90.46-15.16l46.41 46.41a19 19 0 0 0 26.94-26.79zm-163.72-55.98a107.78 107.78 0 0 1 -98.17-152.18l29.95 29.95a69.75 69.75 0 0 0 82.71 82.71l29.95 29.95a107.23 107.23 0 0 1 -44.44 9.57z" />
                            <path
                                d="m506.11 236.81c-59.97-88.81-155.04-140.81-250.11-140.16a271.6 271.6 0 0 0 -90.46 15.16l46 46a107.78 107.78 0 0 1 142.63 142.63l63.74 63.74a332.49 332.49 0 0 0 88.2-89 34.22 34.22 0 0 0 0-38.37z" />
                            <path
                                d="m256 186.26a69.91 69.91 0 0 0 -14.49 1.52l82.71 82.7a69.74 69.74 0 0 0 -68.22-84.22z" />
                        </g>
                    </svg>
                    <svg v-else class="w-6 h-6 fill-gray-500" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 488.85 488.85" style="enable-background:new 0 0 488.85 488.85;"
                        xml:space="preserve">
                        <g>
                            <path
                                d="M244.425,98.725c-93.4,0-178.1,51.1-240.6,134.1c-5.1,6.8-5.1,16.3,0,23.1c62.5,83.1,147.2,134.2,240.6,134.2   s178.1-51.1,240.6-134.1c5.1-6.8,5.1-16.3,0-23.1C422.525,149.825,337.825,98.725,244.425,98.725z M251.125,347.025   c-62,3.9-113.2-47.2-109.3-109.3c3.2-51.2,44.7-92.7,95.9-95.9c62-3.9,113.2,47.2,109.3,109.3   C343.725,302.225,302.225,343.725,251.125,347.025z M248.025,299.625c-33.4,2.1-61-25.4-58.8-58.8c1.7-27.6,24.1-49.9,51.7-51.7   c33.4-2.1,61,25.4,58.8,58.8C297.925,275.625,275.525,297.925,248.025,299.625z" />
                        </g>
                    </svg>
                </div>
            </div>
            <p v-if="errors && errors.new_password_confirmation" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.new_password_confirmation }}
            </p>
        </div>
        <div class="w-full py-8 flex justify-center items-center px-6">
            <button v-if="loading === false" @click="submit" type="button"
                class="w-full font-bold text-center py-4 bg-main text-white rounded shadow"
                :class="{ 'animation_width': loading === true }">
                Cập nhật
            </button>
            <div v-else class="w-16 h-16 bg-main text-white rounded-full flex justify-center items-center">
                <svg class="w-14 h-14 fill-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                    height="512" viewBox="0 0 24 24" width="512">
                    <path
                        d="m12 22c-5.51 0-10-4.49-10-10 0-1.87.52-3.69 1.5-5.27.29-.47.91-.61 1.38-.32s.61.90999.32 1.37999c-.78 1.26-1.2 2.72001-1.2 4.21001 0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10z" />
                </svg>
            </div>
        </div>
    </ModalShow>
    <div v-if="modalLogin" class="absolute top-0 left-0 z-50 bg-black bg-black/30 w-full h-dvh flex justify-center items-center px-10 py-10">
        <div class="w-full bg-white h-auto rounded-2xl overflow-hidden p-4">
            <img src="@/assets/images/Reset_password_compressed.png" alt="" class="w-3/5 object-contain mx-auto">
            <h3 class="font-bold">
                Bạn đã thay đổi mật khẩu thành công!
            </h3>
            <p class="py-2">
                Hãy tiến hành đăng nhập lại để tiếp tục sử dụng lại các dịch vụ và nhận các thông báo hữu ích nhé.
            </p>
            <router-link :to="{name: 'login'}" class="w-full py-2 bg-main text-white rounded-md">
                Đăng nhập
            </router-link>
        </div>
    </div>
</template>